"use client";

import { useEffect, useRef } from "react";

export function useExitAtExpiry(expiresAt: number, exit: () => Promise<unknown>) {
  const exitRef = useRef(exit);
  useEffect(() => {
    exitRef.current = exit;
  });
  useEffect(() => {
    const timer = setTimeout(() => void exitRef.current(), Math.max(0, expiresAt - Date.now()));
    return () => clearTimeout(timer);
  }, [expiresAt]);
}
